import { defineStore } from 'pinia'
import { computed, reactive, ref } from 'vue'

import { UserDependentStore } from './UserDependentStore'

import { IGridState, IMaterialTreeListState, ISparePartPageState } from '@/types/userState'

/** store of the portal state of the currently active user */
export const useUserStateStore = defineStore('userState', () => {
    /********************************************************************************************************************
     STATE
     ********************************************************************************************************************/
    const _state_myDevices = ref<IGridState>({
        gridState: null, 
        idOfCurrentRow: null
    })

    const _state_adminDevices = ref<IGridState>({
        gridState: null,
        idOfCurrentRow: null
    })

    const _state_sparePartTree = reactive<ISparePartPageState>({
        treeListState: null,
        searchText: null
    })

    const _state_sparePartSearchMode = ref<'joni' | 'partner'>('joni')

    const state = { _state_myDevices, _state_adminDevices, _state_sparePartTree, _state_sparePartSearchMode }
    /********************************************************************************************************************
     GETTERS
     ********************************************************************************************************************/
    /** State of the "My devices" grid */
    const myDevicesState = computed(() => _state_myDevices)

    /** State of the "Devices" grid, admin menu */
    const adminDevicesState = computed(() => _state_adminDevices)

    /** State for the "Spare parts overview (old)" (material-tree-list, search-input) */
    const sparePartPageState = computed(() => _state_sparePartTree)

    /** Selected search mode on the "Search by part number" card (joni or partner material number) */
    const sparePartSearchMode = computed(() => _state_sparePartSearchMode.value)

    const getters = { myDevicesState, adminDevicesState, sparePartPageState, sparePartSearchMode }

    /********************************************************************************************************************
     ACTIONS
     ********************************************************************************************************************/
    function setSparePartTreeState(state: IMaterialTreeListState | null) {
        _state_sparePartTree.treeListState = state
    }

    function setSparePartSearchText(searchText: string | null) {
        _state_sparePartTree.searchText = searchText
    }

    function setSparePartSearchMode(mode: 'joni' | 'partner') {
        _state_sparePartSearchMode.value = mode
    }

    function resetAll() {
        _state_myDevices.value = {
            gridState: null,
            idOfCurrentRow: null
        }

        _state_adminDevices.value = {
            gridState: null,
            idOfCurrentRow: null
        }

        setSparePartTreeState(null)
        setSparePartSearchText(null)
        setSparePartSearchMode('joni')
    }

    const actions = {
        setSparePartTreeState,
        setSparePartSearchText,
        setSparePartSearchMode,
        resetAll
    }

    /********************************************************************************************************************
     INITIALIZATION
     ********************************************************************************************************************/
    new UserDependentStore(() => { }, () => resetAll())

    /********************************************************************************************************************
     INTERFACE
     ********************************************************************************************************************/
    return { ...state, ...getters, ...actions }
})